"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var matcher_1 = require("./matcher");
var Config = /** @class */ (function () {
    function Config(_a) {
        var source = _a.source, matcher = _a.matcher, transformer = _a.transformer;
        this.sources = Array.isArray(source) ? source : [source];
        this.matcher = matcher || new matcher_1.Matcher();
        this.transformer = transformer;
    }
    Config.prototype.get = function (key, context) {
        var setting = this.find(key, context);
        return setting && setting.value;
    };
    Config.prototype.getStrict = function (key, context) {
        if (!this.has(key, context)) {
            throw new Error("Setting '" + key + "' is missing in the config!");
        }
        return this.get(key, context);
    };
    Config.prototype.has = function (key, context) {
        var selected = this.selectAndFilterBy(key, context);
        return selected.length > 0;
    };
    Config.prototype.dump = function (keys) {
        var _this = this;
        if (!keys) {
            return this.selectBy();
        }
        var dumpKeys = Array.isArray(keys) ? keys : [keys];
        return dumpKeys.reduce(function (results, key) {
            return results.concat(_this.selectBy(key));
        }, []);
    };
    Config.prototype.dumpForContext = function (keys, context) {
        var _this = this;
        var dumpKeys = Array.isArray(keys) ? keys : [keys];
        return dumpKeys
            .map(function (key) { return _this.find(key, context); })
            .filter(function (entry) { return entry !== null; });
    };
    Config.prototype.attach = function (context) {
        var _this = this;
        return {
            get: function (key) { return _this.get(key, context); },
            has: function (key) { return _this.has(key, context); },
            getStrict: function (key) { return _this.getStrict(key, context); },
            dump: function (keys) { return _this.dump(keys); },
            dumpForContext: function (keys) { return _this.dumpForContext(keys, context); },
            attach: function (ctx) { return _this.attach(ctx); },
        };
    };
    Config.prototype.find = function (key, context) {
        var selected = this.selectAndFilterBy(key, context);
        var setting = selected.reduce(function (top, current) {
            if (!top) {
                return current;
            }
            return current.priority > top.priority ? current : top;
        }, null);
        return this.settingTransform(setting);
    };
    Config.prototype.selectAndFilterBy = function (key, context) {
        var _this = this;
        var selected = this.selectBy(key);
        return selected.filter(function (setting) { return _this.matcher.matches(setting, context); });
    };
    Config.prototype.settingTransform = function (setting) {
        if (!this.transformer || !setting) {
            return setting;
        }
        return this.transformer.transform(setting);
    };
    Config.prototype.selectBy = function (key) {
        return this.sources.reduce(function (results, source) {
            return results.concat(source.select(key));
        }, []);
    };
    return Config;
}());
exports.Config = Config;
//# sourceMappingURL=config.js.map